import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import {
  CouponCodeRequest,
  DataCollectionApi,
} from "../../orchestrator-api-client";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const submitCouponCode = createAsyncThunk<
  CouponCodeRequest,
  CouponCodeRequest,
  ThunkApi
>("submitCouponCode", async (args, { rejectWithValue }) => {
  try {
    await new DataCollectionApi().addCouponCode(args);
    return args;
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error: LayoutError = {
      title: "Salvataggio codice sconto",
      description:
        "Non siamo riusciti a utilizzare il codice sconto.\n Puoi riprovare o contattare il supporto",
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
